export const SET_NAME = 'set name';
export const setName = payload => ({type:SET_NAME,payload});

export const SET_GAME = 'set game';
export const setGame = payload => ({type:SET_GAME,payload});
